
import { yupToFormErrors } from "formik";
import * as Yup from "yup";

const TODIS_KPI_PERIOD_INIT = {
    rangeFrom: "",
    //rangeTo: ""
};
const TODIS_KPI_RANGE_INIT = {
    fromData: "",
    toData: ""
};

const TODIS_KPI_PERIOD_VALID = Yup.object().shape({
    //general section Rules:
    rangeFrom: Yup.string("Range From is alphanumeric").required('Required'),
    //rangeTo: Yup.string("Range To is alphanumeric").required('Required'),
});

const TODIS_KPI_RANGE_VALID = Yup.object().shape({
    //general section Rules:

    fromData: Yup.number()
        .typeError(`Invalid data. Must be a number`)
        .nullable(false)
        .test('is-number', `Invalid data. Must be a number`, function (value) {
            return (value == null || value == undefined || !isNaN(value)) || this.createError({ message: `Invalid data. Must be a number` });
        }).required('Required'),

    toData: Yup.number()
        .typeError(`Invalid data. Must be a number`)
        .nullable(false)
        .test('is-number', 'Invalid data. Must be a number', function (value) {
            return (value == null || value == undefined || !isNaN(value)) || this.createError({ message: `Invalid data. Must be a number` });
        }).required('Required'),
});

const TODIS_KPI_NOISE_INIT = {
    fromData: ""
};
const TODIS_KPI_NOISE_VALID = Yup.object().shape({
    //general section Rules:
    fromData: Yup.number()
    .typeError(`Invalid data. Must be a number`)
    .nullable(false)
    .test('is-number', 'Invalid data. Must be a number', function (value) {
        return (value == null || value == undefined || !isNaN(value)) || this.createError({ message: `Invalid data. Must be a number` });
    }).required('Required')
    
});


export { TODIS_KPI_PERIOD_INIT, TODIS_KPI_PERIOD_VALID, TODIS_KPI_RANGE_INIT, TODIS_KPI_RANGE_VALID, TODIS_KPI_NOISE_INIT, TODIS_KPI_NOISE_VALID };